/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'external-link': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.99 2.469A.572.572 0 0017.43 2h-4.245l-.103.01a.572.572 0 00-.469.561l.01.103a.571.571 0 00.562.469h2.865l-8.222 8.222-.066.079a.572.572 0 00.874.729l8.222-8.222v2.865l.01.103A.572.572 0 0018 6.816V2.571l-.01-.102zM8.858 5.184a.571.571 0 01.103 1.133l-.103.01h-4.49c-.63 0-1.15.477-1.217 1.09l-.007.134v8.082c0 .63.477 1.15 1.09 1.217l.134.007h8.082c.631 0 1.15-.477 1.217-1.09l.008-.134v-4.49a.571.571 0 011.133-.103l.01.103v4.49c0 1.25-.97 2.274-2.199 2.361l-.169.006H4.367c-1.25 0-2.274-.97-2.361-2.198L2 15.632V7.552c0-1.25.97-2.275 2.198-2.361l.17-.006h4.49z" _fill="#1D3861"/>'
  }
})
